import styled from "styled-components";
export const TextArea = styled.textarea `
    resize: vertical;
    min-height: 75px;
`;
